<template>
  <div class="global-setting-page">
    <layout>
      <template v-slot:content>
        <a-form-model
          ref="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :model="model"
          :rules="rules"
          class="form-wrapper"
        >
          <a-spin :spinning="loading">
            <a-form-model-item label="原密码" prop="password_original">
              <a-input-password v-model="model.password_original" />
            </a-form-model-item>

            <a-form-model-item label="新密码" prop="password">
              <a-input-password v-model="model.password" />
            </a-form-model-item>

            <a-form-model-item label="确认密码" prop="password_confirmation">
              <a-input-password v-model="model.password_confirmation" />
            </a-form-model-item>

            <a-form-model-item :wrapper-col="offsetCol">
              <a-button
                type="primary"
                @click="submit"
                :disabled="loading"
              >
                保存
              </a-button>
            </a-form-model-item>
          </a-spin>
        </a-form-model>

      </template>
    </layout>
  </div>
</template>

<style lang="less" scoped>
@import 'PasswordSetting';
</style>

<script>
import PasswordSetting from './PasswordSetting'
export default PasswordSetting
</script>